import { render, staticRenderFns } from "./SaldoInicial.vue?vue&type=template&id=64cc181a&"
import script from "./SaldoInicial.vue?vue&type=script&lang=js&"
export * from "./SaldoInicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports